import React, { useState } from "react";
import { DndProvider, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableChart from "./DraggableChart";
import DraggableCard from "./DraggableCard";
import { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

function DragAndDropDashboards() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [cardPosition, setCardPosition] = useState({ x: 300, y: 100 }); // You can change these default positions

  const [payingUser, setPayingUser] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState(50);

  const [isCustomerPaying, setIsCustomerPaying] = useState(false);
  const [topKeywords, setTopKeywords] = useState(0);
  const [Link, setLink] = useState();
  const [visibleTheUniQueLinkModal, setVisibleTheUniQueLinkModal] =
    useState(false);
  const [selectedColumns, setSelectedColumns] = useState(["keyword"]);
  const [selectedColumnsForTheViewPage, setSelectedColumnsForTheViewPage] =
    useState([]);
  const [
    overallNumberOfKeywordsForAllSites,
    setOverallNumberOfKeywordsForAllSites,
  ] = useState(null);

  const [websiteDomainData, setWebsiteDomainData] = useState([]);
  const [featuredSnippet, setFeaturedSnippet] = useState(false);
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState();
  const [usersWebsite, setUsersWebsite] = useState();
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);

  const [country, setCountry] = useState("United States");
  const [googleDomain, setGoogleDomain] = useState("google.com");
  const [languageCode, setlanguageCode] = useState("en");
  const [countryCode, setCountryCode] = useState("us");
  const [device, setDevice] = useState("");
  const [
    arrayOfKeywordsWithAllInformation,
    setArrayOfKeywordsWithAllInformation,
  ] = useState([]);
  const [firstTimeUser, setFirstTimeUser] = useState(false);

  //FOR THE NUMBER OF KEYWORDS - PAYING / NON PAYING USERS
  const [numberOfKeywordsExceeded, setNumberOfKeywordsExceeded] =
    useState(false);
  const [
    numberOfKeywordsExceededForPayingUser,
    setNumberOfKeywordsExceededForPayingUser,
  ] = useState(false); //THIS ONE ONLY GOES "TRUE" IF A PAYING USER HAS ADDED MORE THAN 100 KEYWORDS.
  //UNTIL HERE*****************

  //FOR THE SUMMARY CARDS
  const [averagePositionForKeywords, setAveragePositionForKeywords] =
    useState(0);
  const [
    yesterdaysAveragePositionForKeywords,
    setYesterdaysAveragePositionForKeywords,
  ] = useState(0);

  const [
    numberOfKeywordsThatHasImprovedSinceYesterday,
    setNumberOfKeywordsThatHasImprovedSinceYesterday,
  ] = useState(0);
  const [numberOfKeywordsInTop3, setNumberOfKeywordsInTop3] = useState(0);
  const [numberOfKeywordsInTop10, setNumberOfKeywordsInTop10] = useState(0);
  const [numberOfKeywordsInTop30, setNumberOfKeywordsInTop30] = useState(0);
  const [numberOfKeywordsInTop100, setNumberOfKeywordsInTop100] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop3,
    setYesterdaysNumberOfKeywordsInTop3,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop10,
    setYesterdaysNumberOfKeywordsInTop10,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop30,
    setYesterdaysNumberOfKeywordsInTop30,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop100,
    setYesterdaysNumberOfKeywordsInTop100,
  ] = useState(0);

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const specificWebsiteId = params.get("id"); // this is the ID that I take from the url.
  console.log("ID:", specificWebsiteId);

  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); //TURNING ON LOADER HERE
    fetchDataOnMount();
  }, []);

  const fetchDataOnMount = async () => {
    console.log("from fetch: ", specificWebsiteId);

    const bodyData = {
      url: specificWebsiteId,
    };

    console.log("Bodydata: ", bodyData);
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_EXISTING_KEYWORD_DATA,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setSubscriptionType(data.paymentInformation.subscriptionType);
        setOverallNumberOfKeywordsForAllSites(
          data.numberOfKeywordsBeingTracked
        );
        setFirstTimeUser(data.firstTimeUser);
        setPayingUser(data.paymentInformation.isCustomerPaying); // JUST A BOOLEAN - TRUE / FALSE
        setIsCustomerPaying(data.paymentInformation.isCustomerPaying); // JUST A BOOLEAN - TRUE / FALSE

        /* updateNumKeywordsLeft(); */

        setWebsiteDomainData(data.trackedUserDomains);
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setEmail(data.email);
        setUsersWebsite(data.website);
        setDevice(data.trackedDevice);
        setCountry(data.trackedCountry);
        setGoogleDomain(data.trackedGoogleDomain);
        setlanguageCode(data.trackedLanguageCode);
        setCountryCode(data.trackedCountryCode);
        const arrayOfKeywordsFromBackend = data?.keywords;

        console.log("specific object: ", data.specificObject);

        const uniqueLink = data?.specificObject?.uniqueSharableLink;
        if (uniqueLink && uniqueLink.length > 0) {
          setLink(uniqueLink);
        }

        const numberOfKeywordsToday = arrayOfKeywordsFromBackend.length;

        setArrayOfKeywordsWithAllInformation(arrayOfKeywordsFromBackend);

        let keywordPositionSumArray = [];
        let yesterdaysKeywordPositionSumArray = [];
        let numberOfImprovedKeywordsArray = [];
        let numberOfKeywordsBetween1And3Array = [];
        let numberOfKeywordsInTop10Array = [];
        let numberOfKeywordsInTop30Array = [];
        let numberOfKeywordsInTop100Array = [];
        let yesterdaysNumberOfKeywordsBetween1And3Array = [];
        let yesterdaysNumberOfKeywordsInTop10Array = [];
        let yesterdaysNumberOfKeywordsInTop30Array = [];
        let yesterdaysNumberOfKeywordsInTop100Array = [];

        //TEHRE IS SOME KIND OF BUG HERE:
        if (Object.keys(arrayOfKeywordsFromBackend).length > 0) {
          arrayOfKeywordsFromBackend.map((e, index) => {
            const lowestNumber = e.historicRankingsForThisKeyword.reduce(
              (a, b) => (a.rankingPosition < b.rankingPosition ? a : b),
              { rankingPosition: Infinity }
            );
            console.log("lowest number ", lowestNumber);

            const firstTrackedPosition =
              e.historicRankingsForThisKeyword[0]?.rankingPosition; // THIS IS THE POSITION THAT WAS THE FIRST ONE WHEN KEYWORD WAS FIRST ADDED.
            const latest =
              e.historicRankingsForThisKeyword.slice(-1)[0]?.rankingPosition ||
              Infinity;
            // THIS IS GIVING BACK THE LAST ONE IN THE ARRAY
            /* const previousToLatest =
            e.historicRankingsForThisKeyword.slice(-2)[0]?.rankingPosition ||
            Infinity; */
            const historicRankings = e.historicRankingsForThisKeyword;
            const previousToLatest =
              historicRankings.length <= 1
                ? "-"
                : historicRankings.slice(-2)[0]?.rankingPosition || Infinity;
            // THIS IS GIVING BACK THE SECOND LATEST POSITION IN THE ARRAY
            const change = latest - previousToLatest;
            console.log("change", change);
            if (change < 0) {
              //IF THE KEYWORD HAS IMPROVED IN RANKING (MEANING THAT IT IS MINUS) , THEN I PUSH "1" TO THE ARRAY
              numberOfImprovedKeywordsArray.push(1);
            }
            //THIS IS FOR CALCULATING THE AVERAGE POSITION
            if (Number.isInteger(e.currentRankingPosition))
              keywordPositionSumArray.push(e.currentRankingPosition);
            //THIS IS FOR CALCULATING YESTERDAYS AVERAGE POSITION
            if (Number.isInteger(previousToLatest))
              yesterdaysKeywordPositionSumArray.push(previousToLatest);

            //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (e.currentRankingPosition <= 3) {
              numberOfKeywordsBetween1And3Array.push(1);
            }
            if (e.currentRankingPosition <= 10) {
              numberOfKeywordsInTop10Array.push(1);
            }
            if (e.currentRankingPosition <= 30) {
              numberOfKeywordsInTop30Array.push(1);
            }
            if (e.currentRankingPosition <= 100) {
              numberOfKeywordsInTop100Array.push(1);
            }
            //BELOW I AM CALCULATING YESTERDAYS NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (previousToLatest <= 3) {
              yesterdaysNumberOfKeywordsBetween1And3Array.push(1);
            }
            if (previousToLatest <= 10) {
              yesterdaysNumberOfKeywordsInTop10Array.push(1);
            }
            if (previousToLatest <= 30) {
              yesterdaysNumberOfKeywordsInTop30Array.push(1);
            }
            if (previousToLatest <= 100) {
              yesterdaysNumberOfKeywordsInTop100Array.push(1);
            }

            const best = lowestNumber?.rankingPosition || Infinity;
            const first = firstTrackedPosition || Infinity;
            const last_updated = e.lastUpdate || Infinity;
            const url_ranking = e.URLRanking || Infinity;

            const featuredSnippetDisplayedLink = e.allSerpInfoForKeyword?.link;

            const hasFeaturedSnippet = Boolean(featuredSnippetDisplayedLink);
            console.log("hasFeaturedSnippet:", hasFeaturedSnippet);
            if (hasFeaturedSnippet) {
              setFeaturedSnippet(true);
            }

            /* console.log("Lowest number ", lowestNumber); */

            const keywordNeedsToBeUpdated = e.keywordNeedsToBeUpdatedFirstTime;
            /* console.log("keywordNeedsToBeUpdated:", keywordNeedsToBeUpdated); */

            //These moment consts are used for calculating the time since last update , which is used in the table.
            const momentLastUpdated = moment(last_updated);
            const timeDifference = moment().diff(momentLastUpdated);
            const formattedLastUpdated =
              moment.duration(timeDifference).humanize() + " ago";

            if (keywordNeedsToBeUpdated) {
              const latestChange = setNewDataSourceForTheTable((data) => [
                ...data,
                {
                  key: index + 1,
                  keyword: e.keyword,
                  change: 0,
                  latest: Infinity,
                  yesterday: previousToLatest || 0,
                  best: Infinity,
                  first: Infinity,
                  last_updated: Infinity,
                  url_ranking: Infinity,
                  action: "delete",
                },
              ]);
            } else {
              const latestChange = setNewDataSourceForTheTable((data) => [
                ...data,
                {
                  key: index + 1,
                  keyword: e.keyword,
                  change: change || 0,
                  latest: latest || 0,
                  yesterday: previousToLatest || 0,
                  best: best,
                  first: first,
                  featured_snippet: featuredSnippetDisplayedLink,
                  last_updated: formattedLastUpdated, //moment date from above. To calculate time since last update
                  url_ranking: url_ranking,
                  action: "delete",
                },
              ]);
            }
          });
          //BELOW HERE I AM DOING ALL THE CALCULATIONS FOR THE SUMMARY CARDS BASED ON THE ARRAYS I AM PUSHING INTO ABOVE

          //CALCULATING TODAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllCurrentPositions = keywordPositionSumArray.reduce(
            //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
            (partialSum, a) => partialSum + a,
            0
          );

          const averagePosition =
            sumOfAllCurrentPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

          const first4StrOfAveragePosition = String(averagePosition).slice(
            // I JUST NEED THE FIRST 4 STRINGS
            0,
            4
          ); // I ONLY WANT THE FIRST 4 NUMBERS (IN CASE IT IS A VERY LONG NUMBER)
          console.log(first4StrOfAveragePosition);
          setAveragePositionForKeywords(first4StrOfAveragePosition);

          //CALCULATING YESTERDAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllYesterdaysPositions =
            yesterdaysKeywordPositionSumArray.reduce(
              //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
              (partialSum, a) => partialSum + a,
              0
            );
          const yesterdaysAveragePosition =
            sumOfAllYesterdaysPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

          const first4StrOfYesterdaysAveragePosition = String(
            // I JUST NEED THE FIRST 4 STRINGS
            yesterdaysAveragePosition
          ).slice(0, 4);
          setYesterdaysAveragePositionForKeywords(
            first4StrOfYesterdaysAveragePosition
          );

          //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS THAT HAVE IMPROVED SINCE THE DAY BEFORE.
          const numberOfKeywordsThatImproved =
            numberOfImprovedKeywordsArray.length;

          setNumberOfKeywordsThatHasImprovedSinceYesterday(
            numberOfKeywordsThatImproved
          );
          //BELOW I AM CALCULATING THE LENGTH OF THE "KEYWORDS IN TOP 3/10/30/100" ARRAYS
          //AND SETTING THEM IN STATE.
          const numberOfKeywordsInTop3 =
            numberOfKeywordsBetween1And3Array.length;
          const numberOfKeywordsInTop10 = numberOfKeywordsInTop10Array.length;
          const numberOfKeywordsInTop30 = numberOfKeywordsInTop30Array.length;
          const numberOfKeywordsInTop100 = numberOfKeywordsInTop100Array.length;

          setNumberOfKeywordsInTop3(numberOfKeywordsInTop3);
          setNumberOfKeywordsInTop10(numberOfKeywordsInTop10);
          setNumberOfKeywordsInTop30(numberOfKeywordsInTop30);
          setNumberOfKeywordsInTop100(numberOfKeywordsInTop100);

          //BELOW I AM CALCULATING THE LENGTH OF "YESTERDAYS KEYWORDS IN TOP 3/10/30/100" ARRAYS
          //AND SETTING THEM IN STATE.

          const yesterdaysNumberOfKeywordsInTop3 =
            yesterdaysNumberOfKeywordsBetween1And3Array.length;
          const yesterdaysNumberOfKeywordsInTop10 =
            yesterdaysNumberOfKeywordsInTop10Array.length;
          const yesterdaysNumberOfKeywordsInTop30 =
            yesterdaysNumberOfKeywordsInTop30Array.length;
          const yesterdaysNumberOfKeywordsInTop100 =
            yesterdaysNumberOfKeywordsInTop100Array.length;

          setYesterdaysNumberOfKeywordsInTop3(yesterdaysNumberOfKeywordsInTop3);
          setYesterdaysNumberOfKeywordsInTop10(
            yesterdaysNumberOfKeywordsInTop10
          );
          setYesterdaysNumberOfKeywordsInTop30(
            yesterdaysNumberOfKeywordsInTop30
          );
          setYesterdaysNumberOfKeywordsInTop100(
            yesterdaysNumberOfKeywordsInTop100
          );
        }
      } else if (response.status === 503) {
        const data = await response.json();

        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setIsCustomerPaying(data.paymentInformation.isCustomerPaying);
      } else if (response.status === 401) {
        console.log("Token not valid");
        window.location.replace("/login"); // I AM ADDING THIS ONE , SO THAT THE USER WILL BE REDIRECTED TO THE LOGIN PAGE IN CASE THE TOKEN IS EXPIRED.
      }
    } catch (error) {
      console.log(error);
    }
  };

  const chartData = {
    labels: ["January", "February", "March", "April", "May"],
    datasets: [
      {
        label: "Sample Data",
        data: [12, 19, 3, 5, 2],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  const statToPositionKey = {
    "Keywords in Top 3": "top3",
    "Keywords in Top 10": "top10",
    "Keywords in Top 30": "top30",
    "Keywords in Top 100": "top100",
    "Average Position": "averageposition",
    "Improved Keywords": "improvedkeywords",
  };

  const [cardPositions, setCardPositions] = useState({
    top3: { x: 0, y: 0 },
    top10: { x: 270, y: 0 },
    top30: { x: 540, y: 0 },
    top100: { x: 810, y: 0 },
    averageposition: { x: 1080, y: 0 },
    improvedkeywords: { x: 1350, y: 0 },
  });

  const [, drop] = useDrop({
    accept: "CARD",
    drop(item, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset();
      const id = item.id; // this will now be the name of the card

      setCardPositions((prevPositions) => ({
        ...prevPositions,
        [statToPositionKey[id]]: {
          // Use statToPositionKey to get the correct key
          x: prevPositions[statToPositionKey[id]].x + delta.x,
          y: prevPositions[statToPositionKey[id]].y + delta.y,
        },
      }));
    },
  });

  const cardWidth = 250;
  const gap = 20;

  const stats = [
    {
      name: "Average Position",
      stat: averagePositionForKeywords,
      previousStat:
        typeof yesterdaysAveragePositionForKeywords !== "undefined"
          ? yesterdaysAveragePositionForKeywords
          : 0,

      change: parseFloat(
        (
          averagePositionForKeywords - yesterdaysAveragePositionForKeywords
        ).toFixed(2)
      ),
      changeType:
        averagePositionForKeywords < yesterdaysAveragePositionForKeywords
          ? "increase"
          : averagePositionForKeywords === yesterdaysAveragePositionForKeywords
          ? "same"
          : "decrease",
    },
    {
      name: "Improved Keywords",
      stat: numberOfKeywordsThatHasImprovedSinceYesterday,
      previousStat: null,
      change: numberOfKeywordsThatHasImprovedSinceYesterday,
      changeType:
        numberOfKeywordsThatHasImprovedSinceYesterday > 0
          ? "increase"
          : numberOfKeywordsThatHasImprovedSinceYesterday === 0
          ? "same"
          : "decrease",
    },

    {
      name: "Keywords in Top 3",
      stat: numberOfKeywordsInTop3,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop3 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop3
          : 0,
      change: numberOfKeywordsInTop3 - yesterdaysNumberOfKeywordsInTop3,
      changeType:
        numberOfKeywordsInTop3 > yesterdaysNumberOfKeywordsInTop3
          ? "increase"
          : numberOfKeywordsInTop3 === yesterdaysNumberOfKeywordsInTop3
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 10",
      stat: numberOfKeywordsInTop10,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop10 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop10
          : 0,
      change: numberOfKeywordsInTop10 - yesterdaysNumberOfKeywordsInTop10,
      changeType:
        numberOfKeywordsInTop10 > yesterdaysNumberOfKeywordsInTop10
          ? "increase"
          : numberOfKeywordsInTop10 === yesterdaysNumberOfKeywordsInTop10
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 30",
      stat: numberOfKeywordsInTop30,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop30 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop30
          : 0,
      change: numberOfKeywordsInTop30 - yesterdaysNumberOfKeywordsInTop30,
      changeType:
        numberOfKeywordsInTop30 > yesterdaysNumberOfKeywordsInTop30
          ? "increase"
          : numberOfKeywordsInTop30 === yesterdaysNumberOfKeywordsInTop30
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 100",
      stat: numberOfKeywordsInTop100,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop100 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop100
          : 0,
      change: numberOfKeywordsInTop100 - yesterdaysNumberOfKeywordsInTop100,
      changeType:
        numberOfKeywordsInTop100 > yesterdaysNumberOfKeywordsInTop100
          ? "increase"
          : numberOfKeywordsInTop100 === yesterdaysNumberOfKeywordsInTop100
          ? "same"
          : "decrease",
    },
  ];

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        ref={drop}
        style={{ position: "relative", width: "100vw", height: "100vh" }}
      >
        {stats.map((item, index) => {
          const positionKey = statToPositionKey[item.name];

          return (
            <DraggableCard
              key={item.name} // Use name as a key
              id={item.name} // This is redundant, you can remove this since we are using name directly in DraggableCard
              x={cardPositions[positionKey].x}
              y={cardPositions[positionKey].y}
              title={item.name}
              count={item.stat}
              change={item.change}
              previousStat={item.previousStat}
              changeType={item.changeType}
              name={item.name}
            />
          );
        })}

        {/* <DraggableChart data={chartData} x={position.x}    /> */}
      </div>
    </DndProvider>
  );
}

export default DragAndDropDashboards;
